import "../../styles/style"
import "../../fixed-view/style"
import "../../badge/style"
import "../index.scss"
